import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { groupStoresByState, buildDetailUrl, STORE_TYPE_PARTNER } from './helpers';
const StoreLocatorViewAll = t0 => {
  const $ = _c(5);
  const {
    stores,
    onActivate
  } = t0;
  let t1;
  let t2;
  if ($[0] !== onActivate || $[1] !== stores) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const grouped = groupStoresByState(stores || []);
      const stateKeys = Object.keys(grouped);
      if (stateKeys.length === 0) {
        let t3;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <div className="py-4 text-sm text-gray">No showrooms available.</div>;
          $[4] = t3;
        } else {
          t3 = $[4];
        }
        t2 = t3;
        break bb0;
      }
      t1 = <div className="text-base">{stateKeys.map(state => <div key={state} className="mb-5"><h2 className="text-lg text-brand font-bold mb-1">{state}</h2><ul className="space-y-1">{grouped[state].map(store => {
              const isPartner = store.type === STORE_TYPE_PARTNER;
              const detailUrl = buildDetailUrl(store);
              return <li key={store.id}><a href={detailUrl} onClick={() => onActivate && onActivate(store.id)} className="text-base text-brand underline hover:text-gray-dark">{store.name || store.city}</a>{isPartner && <span className="ml-2 text-sm text-gray-light2">(Partner Studio)</span>}</li>;
            })}</ul></div>)}</div>;
    }
    $[0] = onActivate;
    $[1] = stores;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  return t1;
};
StoreLocatorViewAll.propTypes = {
  stores: PropTypes.array.isRequired,
  onActivate: PropTypes.func
};
export default StoreLocatorViewAll;